import { getStore } from '../store/store';

export const isThinking = (): boolean => {
    return getStore().isThinking;
};
